import { ai } from '@sloyd/api';
import { actions } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { delay, fork, put, takeEvery } from 'saga-ts';
import { l } from 'shared-base';

export const saga = {
  id: 'sloyd.studio',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['STUDIO'],
  },
};

type Verb = 'textaco'; //

type Action = {
  type: 'STUDIO';
  verb: Verb;
  id: string;
  payload: Json;
  promise?: any;
  reject?: any;
};

const map: Record<Verb, any> = {
  textaco: textaco,
};

export function* textaco(action: Action) {
  const { payload } = action;
  const { prompt } = payload;

  let res;

  const generatorId = '67e30af8-813a-4589-b2d1-0ba618e7016b';

  yield put(actions.appState.patch({ isAiRunning: true }));
  res = yield ai.texturize(prompt, generatorId);
  yield put(actions.appState.patch({ isAiRunning: false }));
  const { data, isSuccess, error } = res;

  if (!isSuccess) {
    toast.error(error);
    return;
  }

  const { material_id_to_texture_id, _selected_textures } = data;
}

export function* studio(action: any) {
  const { verb, id } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.studio ${verb} on ${id}`);

  yield* fork(saga, action);
}

export function* root() {
  return;
  yield takeEvery('STUDIO', studio);
}
